export default __webpack_public_path__ + "static/media/yellowTheme-girl.a7ec3ad5.svg";